import React, { FC, useEffect, useRef, useState } from 'react';
import styled from '@emotion/native';

import Text from '@components/1-atoms/Text';
import Modal from '@components/1-atoms/Modal';

import Input, {Props as FieldProps} from '@components/2-molecules/Input';

import { Calendar as BaseCalendar } from 'react-native-calendars';
import * as utils from '@lib/utils';

import Down from '@assets/icons/down';
import DateIcon from '@assets/icons/calendar';
import { View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';

// ${props => (props?.theme?.contentWidth) && `
//   width: ${props.theme.contentWidth}px;
// `}

const Calendar = styled(BaseCalendar)`
  width: ${({ theme }: any) => `${Math.min(500, theme.contentWidth)}px` };
`;

type Props = FieldProps & {
  defaultValue?: string | number | Date | null;
  dateFormat?: string;
  onChange?: (value: Date | string | number | null | any) => void;
  label?: string;
  required?: boolean;
  mini?: boolean;
};

const DateInput: FC<Props> = ({ defaultValue, dateFormat, /* mini, */ onChange, ...props }) => {

  const [date, setDate] = useState<string | number | Date | null | undefined>(defaultValue);
  const [text, setText] = useState(date ? utils.formatDate(date, dateFormat) : "");
  
  const [isModalVisible, setModalVisiblility] = useState(false);
  const openModal = () => setModalVisiblility(true);
  const closeModal = () => setModalVisiblility(false);

  useEffect(() => { setDate(defaultValue) }, [defaultValue]);

  useEffect(() => {
    setText(date ? utils.formatDate(date, dateFormat) : "");
    onChange?.(date);
  }, [date]);

  const update = (date: any) => {
    date = date.timestamp || date;
    setDate(date);
    closeModal();
  }

  const _onBlur = () => {
    const newDate : Date = new Date(text || '');
    // Check if it's a valid date
    if (!isNaN(newDate.getTime())) {
      setDate(newDate);
    }
    props.onBlur?.();
  };

  const selected:string = date ? utils.formatDate(new Date(date), "yyyy-MM-dd") : "";

  const right = <TouchableOpacity onPress={openModal}>
    <DateIcon />
  </TouchableOpacity>;

  return (
   <View>
      <Modal visible={isModalVisible} title={props.label || "Select date"} onClose={closeModal}>
        <Calendar
          current={selected}
          markedDates={{
              [selected]: { selected: true, selectedColor: '#2F80ED' }
            }}
          onDayPress={update}
          renderArrow={(direction: string) => {
              const label = (direction == "left") ? "Prev" : "Next";
              return (<Text> {label} </Text>)
          }}
        />
      </Modal>
      
     <Input
        right={right}
        defaultValue={text}
        onBlur={_onBlur}
        onPress={openModal}
        onChange={(value) => { setText(value) }}
        {...props} />
   </View>
  );
};

export default DateInput;